export enum InviteType {
  EMAIL = 'email',
  SMS = 'sms',
}
